import { render, staticRenderFns } from "./history.vue?vue&type=template&id=c6e59ef4&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=c6e59ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e59ef4",
  null
  
)

export default component.exports